import {
    ItemStatus,
    AttachmentInfo,
    EntityStatus,
	ListItem,	AppUserInfo,
    LookupListItem
} from "./entities";
import { AppEntity } from "./app-entity";
import { association, resource, repository, validatedResource} from 'aurelia-orm';
import { ValidationRules } from 'aurelia-validation';
import { ItemRepository } from '../repository/item-repository';

@resource("item")
@validatedResource()
@repository(ItemRepository)
export class Item extends AppEntity {
    processStep: LookupListItem;
    processStepId: number;

	constructor() {
		super();

		ValidationRules
			.ensure('name').required()
			.ensure('name').maxLength(200)
			.ensure('timeScaleTypeId').required().when((item: Item) => item.timeEstimate !== null).withMessage("Time Scale is required")
			.ensure('dueDate').satisfies(this.checkDueDate).when((item: Item) => item.startDate !== null && item.dueDate !== null)
			.withMessage("Due Date must be later than Start Date")

			.on(Item);
	}

	checkDueDate(value, item) {
		//DatePicker returns value as string, not date
		const dueDate = new Date(value);
		const startDate = new Date(item.startDate);
		const isValid = dueDate >= startDate;
		return isValid;
	}

    id: number;
    name: string;
	description: string;
	risk: string;
	details: string;
	note: string;
	entityStatusId: number;
	folderName: string;
	itemTags: Array<object> = [];
	isChecked: boolean;
	//@association('itemStatus')
	entityStatus: EntityStatus;

	//closeStatus: CloseStatus;

    parentId: number;
    //guid: string;

	ownedById: number;
	ownedByName: string;

	assignedToId: number;

	assignedTo: AppUserInfo;

	assignedToName: string;

    //@type("date")
	startDate: Date;

	closeDate: Date;

    //@type('date')
    dueDate: Date;

    budget: number;
    cost: number;
    progress: number;
	itemStatusId: number;
	itemStatusTypeId: number;

    //@association('statusType')
    itemStatus: ItemStatus;

    isEditing = false;

    test() {
        console.log("hello from item");
    }

    @association('comment')
	comments: Array<Comment>;

	@association('history')
	history: Array<History>;

    @association('attachmentInfo')
    attachmentInfos: Array<AttachmentInfo>;

    importanceTypeId: number;

    //@association('importanceType')
    importanceType: LookupListItem;

    priorityTypeId: number;

    //@association('priorityType')
	priorityType: LookupListItem;

	timeScaleType: LookupListItem;

	timeEstimate: number;

	timeScaleTypeId: number;

	itemTypeId: number;

	isClosedFolder: boolean;

    //@association()
    itemType: LookupListItem;
   

    @association('item')
    children: Array<Item> = [];

    @association("listItem")
    listItems: Array<ListItem>;

	showDetails: boolean;
}